// extracted by mini-css-extract-plugin
export default {"container":"BookingSuccess_container__v4TVl","message":"BookingSuccess_message__aejTk","info":"BookingSuccess_info__r84hT","backButton":"BookingSuccess_backButton__mX6X7"};